import React, {useRef, useState} from 'react';
import * as events from "events";
import _axios from "../../../httpService";
import Loader from "../../Loader";

const AdminFilters = (props) => {

  //after select programmers
  const [programmersList, setProgrammersList] = useState(null)
  // after select Tasks
  const [taskSection, setTaskSection] = useState(false)
  // after select yearMonth
  const [yearMonthSection, setYearMonthSection] = useState(false)
  const [yearHolder, setYearHolder] = useState("")
  const [monthHolder, setMonthHolder] = useState("")
  const [showMonthSection, setShowMonthSection] = useState(false)

  const [programmersSection, setProgrammersSection] = useState(false)
  const [showTaskSection, setShowTaskSection] = useState(false)
  const [taskList, setTaskList] = useState(false)
  const taskListRef = useRef();


  const onChangeSelectYear = event => {
    const tempYearHolder = event.target.value;
    setYearHolder(event.target.value)
    setShowMonthSection(true)
    if (monthHolder.length > 0) {
      props.onFilter({type: "yearMonth", year: tempYearHolder, month: monthHolder})

    }
  }

  const onChangeSelectMonth = event => {
    const tempMonthHolder = event.target.value
    setMonthHolder(event.target.value)
    /**/
    props.onFilter({type: "yearMonth", year: yearHolder, month: tempMonthHolder})
  }

  const onChangeProgrammersSelectType1 = (event) => {
    props.onFilter(event.target.value)
  }


  const onchangeType1 = (event) => {

    if (event.target.value === "0") {
      props.onFilter(event.target.value)
      // props.onFilter("")
      setProgrammersList(null)
      return
    }
    if (event.target.value === "requestProgrammers") {
      //show Programmers
      _axios.get(localStorage.getItem("apiUrl") + "/filterData/?filterName=programmers")
        .then(data => {
          setProgrammersList(data.data)
        })

    }
  }
  const onchangeType2 = (event) => {

    if (event.target.value === "all") {
      setYearMonthSection(false);
      setShowMonthSection(false);
      setProgrammersSection(false)
      props.onFilter({type: "all", year: "", month: ""})
    }

    if (event.target.value === "yearMonth") {
      setYearMonthSection(true);
      setProgrammersSection(false)
      setTaskSection(false)
    }

    if (event.target.value === "programmersSection") {
      _axios.get(localStorage.getItem("apiUrl") + "/filterData/?filterName=programmers")
        .then(data => {
          setProgrammersList(data.data);
          setProgrammersSection(true)
          // setTaskSection(true);
          setYearMonthSection(false)
          setShowMonthSection(false)
        })
    }
  }
  const onChangeProgrammersSelectToShowTasks = (event) => {
    _axios.get(localStorage.getItem("apiUrl") + "/filterData/?filterName=task&ProgrammerId=" + event.target.value)
      .then(data => {
        // setShowTaskList(data.data)
      })

  }
  const rnd1 = Math.floor(Math.random() * 100000000000) + "";
  const rnd2 = Math.floor(Math.random() * 100000000000) + "";
  const rnd3 = Math.floor(Math.random() * 100000000000) + "";

  function onChangeProgrammerList(event) {
    const taskId = event.target.value;
    _axios.get(localStorage.getItem("apiUrl") + "/filterData/?filterName=task&programmerId=" + taskId)
      .then(data => {
        setTaskList(data.data);
        setShowTaskSection(true)
        taskListRef.current.value = "nullSelect"
      }).catch(error => {
      console.log(error)
    })


    // setShowTaskSection(true);
    // setTaskList([{"id":"1","name":"1"},{"id":"2","name":"سیستم دسترسی کاربران، ثبت وقایع و پشتیبان گیری، ویرایش فاکتور فروش، جست و جو بر اساس کد کالا اینترنتی، اضافه کردن تیک تریگر ها، چک کردن موجودی کالا در فاکتور فروش کل"},{"id":"3","name":"سیستم دسترسی کاربران\r\nثبت وقایع و پشتیبان گیری برداشته شود\r\nدسترسی به رگوردهای خودش درست کار کند\r\nبوت استرپ لینگ گذاشته شود\r\nورژن چدید تا قبل از پرینت گذاشته شود.\r\nویرایش فاکتور چگ شود\r\nتغییرات فاکتور"},{"id":"6","name":"سلکت یوزرهای لاگین\r\nپرینت بر اساس کد کالا و کد کالای اینترنتی در صفحه اصلی گذاشته شود\r\nپرینت بارکد در فهرست گذاشته شود\r\nفاکتور در موبایل خوب کار کند\r\nپرینت فاکتور در سایز کوچک \r\nپرینت فاکتور در سایز ب"},{"id":"7","name":"تنظیمات بارکد اضافه شود. تنظیمات فقط برای مدیر نمایش داده شود. دسترسی به فاکتور ها در بک تعیین شود"},{"id":"8","name":"ساخت تنظیمات بارکد با جزییات سایز و تعداد بارکد و انتخاب ایتم های درون بارکد"},{"id":"9","name":"رفع مشکلات روان حساب (علی طاهری)"},{"id":"10","name":"باگ های روانحساب(1401/02/29)"},{"id":"11","name":"مهندس میرعرب\r\nفاکتور در سایز کوچک\r\nاصلاحات پرینت\r\nبارکد در صفحه اصلی طبق تغییرات درست کار کند\r\nلوگو در فاکتور بنشیند\r\n"},{"id":"12","name":"دریافت اطلاعات از بک و تکمیل درکمه های تایید یا رد درخواست ثبت فروشگاه لیست نمایندگان- بارکد گروهی "},{"id":"13","name":"تکمیل پنل نماینده-صدور دسته ای بارکد"},{"id":"14","name":"ساخت دیتابیس،ثبت نام و ورود کاربر، فاکتور کل و فاکتور جزء، درگاه پرداخت"},{"id":"15","name":"رفع باگ های روان حساب"},{"id":"16","name":"رفع باگ های روان حساب و افزودن ترازنامه و نمودار"},{"id":"17","name":"افزودن پنل نکاربر عمومی،ثبت نام و ثبت سفارش"},{"id":"18","name":"اصلاح برخی از باگ های روان حساب"},{"id":"19","name":"پروژه نمایندگان پست در کشور های مختلف"},{"id":"20","name":"پیاده سازی UI آنیپو"},{"id":"21","name":"پیاده سازی نسخه لاراول روانحساب"},{"id":"22","name":"میرعرب 2- KPI روان حساب"},{"id":"23","name":"طراحی قالب اتوماسیون"},{"id":"24","name":"طراحی فلوچارت "},{"id":"25","name":"تغییر کلاس ها و استایل فرم های رسا"},{"id":"26","name":"پیاده سازی قالب جدید داشبورد رسا و تغییرات عملکردی آن"},{"id":"27","name":"لاگین و ورود"},{"id":"28","name":"تست لاگین و ورود"},{"id":"29","name":"اضافه سازی بخش شاخص ساز-اضافه کردن پرداخت نقدی و حساب بانکی به فاکتور ها"},{"id":"30","name":"رفع باگ های پنل ادمین آنیپو\nافزودن رهگیری به سفارشات بایگانی شده\nافزودن ویجت ها \nتب رهگیری و زیر منوی باجه معطله و میانگین زمان\n ارسال\nتب گزارشات و زیر منوی بسته ها"},{"id":"31","name":"صفحات لاگین و رجیستر و وریفای \nکامپوننت بندی صفحه داشبورد"},{"id":"32","name":"ثبت نام و لاگین"},{"id":"33","name":"تست وب سرویس رهگیری و اضافه کردن ستون های جدید به جدول بارکد ها"},{"id":"34","name":"رفع باگ های پنل ادمین ک توسط مهندس حاجیلری باگ گیری شد"},{"id":"35","name":"رفع باگ وب سرویس، گزارش بسته ها"},{"id":"36","name":"نسخه موبایلی ورکان"},{"id":"37","name":"درگاه پرداخت"},{"id":"38","name":"تکمیل سایت ورکان"},{"id":"39","name":"ولیدیشن های فرم ثبت نام و لاگین و ثبت آدرس منتخب و پاک کردنش"},{"id":"40","name":"برطرف کردن باگ ها و تبدیل جدول گزارشات آنیپو به نمودار"}])


    // console.log(event.target.value)
  }

  function onChangeTaskSelectType2(event) {
    props.onFilter({type: "task", taskId: event.target.value})
  }


  return (
    <>
      {
        props.filterType === "type1" &&
        <>
          <div style={{"margin": "5px"}}>
            <div

              style={{}}
            >
              <div
                style={{}}
              >
                <div className="form-control0">
                  <input value={"0"} onChange={onchangeType1} className="form-check-input" type="radio"
                         name={rnd1} id={rnd1}/>
                  <label className="form-check-label" htmlFor={rnd1}>
                    همه
                  </label>
                </div>
                <div className="form-control0">
                  <input value={"requestProgrammers"} onChange={onchangeType1} className="form-check-input" type="radio"
                         name={rnd1} id={rnd2}
                  />
                  <label className="form-check-label" htmlFor={rnd2}>
                    برنامه نویس
                  </label>
                </div>
              </div>

              {programmersList !== null &&
                <div style={{}}>
                  <select onChange={onChangeProgrammersSelectType1} defaultValue={"nullSelect"}
                          className="form-select form-select mb-3" aria-label=".form-select-lg example">
                    <option hidden={true} value={"nullSelect"}>لطفا یک برنامه نویس را انتخاب کنید.</option>
                    {
                      programmersList.map((v) => <option value={v.id}>{v.name}</option>)
                    }
                  </select>
                </div>
              }
            </div>

          </div>
        </>
      }
      {
        props.filterType === "type2" &&
        <>
          <div className={""}>
            <div className="form-control0">
              <input value={"all"} onChange={onchangeType2} className="form-check-input" type="radio"
                     name={rnd1} id={rnd1}/>
              <label className="form-check-label" htmlFor={rnd1}>
                همه
              </label>
            </div>
            <div className="form-control0">
              <input value={"yearMonth"} onChange={onchangeType2} className="form-check-input" type="radio"
                     name={rnd1} id={rnd2}
              />
              <label className="form-check-label" htmlFor={rnd2}>
                سال و ماه
              </label>
            </div>
            <div className="form-control0">
              <input value={"programmersSection"} onChange={onchangeType2} className="form-check-input" type="radio"
                     name={rnd1} id={rnd3}
              />
              <label className="form-check-label" htmlFor={rnd3}>
                تسک برنامه نویس
              </label>
            </div>
            {/*  ***************************************************************************************************/}
            {/* show year month Please */}

            {/*{taskSection && <>*/}
            {/*  <div className="form-control0">*/}
            {/*    {programmersList !== null &&*/}
            {/*      <div style={{}}>*/}
            {/*        <select onChange={onChangeProgrammersSelectToShowTasks} defaultValue={"nullSelect"}*/}
            {/*                className="form-select form-select mb-3" aria-label=".form-select-lg example">*/}
            {/*          <option hidden={true} value={"nullSelect"}>لطفا یک برنامه نویس را انتخاب کنید.</option>*/}
            {/*          {*/}
            {/*            programmersList.map((v) => <option value={v.id}>{v.name}</option>)*/}
            {/*          }*/}
            {/*        </select>*/}
            {/*      </div>*/}
            {/*    }*/}
            {/*  </div>*/}
            {/*  {showTaskList &&*/}
            {/*    <div className="form-control0">*/}
            {/*      <div style={{}}>*/}
            {/*        <select onChange={onChangeProgrammersSelectToShowTasks} defaultValue={"nullSelect"}*/}
            {/*                className="form-select form-select mb-3" aria-label=".form-select-lg example">*/}
            {/*          <option hidden={true} value={"nullSelect"}>لطفا یک برنامه نویس را انتخاب کنید.</option>*/}
            {/*          {*/}
            {/*            showTaskList.map((v) => <option value={v.id}>{v.name}</option>)*/}
            {/*          }*/}
            {/*        </select>*/}
            {/*        }*/}
            {/*      </div>*/}
            {/*    </div>*/}
            {/*  }*/}
            {/*</>}*/}

            {yearMonthSection === true ? <>
              <div className="form-control0">
                <div style={{}}>
                  <select onChange={onChangeSelectYear} defaultValue={"nullSelect"}
                          className="form-select form-select mb-3" aria-label=".form-select-lg example">
                    <option hidden={true} value={"nullSelect"}>سال</option>
                    <option value={"1395"}>1395</option>
                    <option value={"1396"}>1396</option>
                    <option value={"1397"}>1397</option>
                    <option value={"1398"}>1398</option>
                    <option value={"1399"}>1399</option>
                    <option value={"1400"}>1400</option>
                    <option value={"1401"}>1401</option>
                    <option value={"1402"}>1402</option>
                    <option value={"1403"}>1403</option>
                    <option value={"1404"}>1404</option>
                    <option value={"1405"}>1405</option>

                  </select>
                </div>
                {showMonthSection && <div style={{}}>
                  <select onChange={onChangeSelectMonth} defaultValue={"nullSelect"}
                          className="form-select form-select mb-3" aria-label=".form-select-lg example">
                    <option hidden={true} value={"nullSelect"}>ماه</option>
                    <option value={"فروردین"}>فروردین</option>
                    <option value={"اردیبهشت"}>اردیبهشت</option>
                    <option value={"خرداد"}>خرداد</option>
                    <option value={"تیر"}>تیر</option>
                    <option value={"مرداد"}>مرداد</option>
                    <option value={"شهریور"}>شهریور</option>
                    <option value={"مهر"}>مهر</option>
                    <option value={"آبان"}>آبان</option>
                    <option value={"آذر"}>آذر</option>
                    <option value={"دی"}>دی</option>
                    <option value={"بهمن"}>بهمن</option>
                    <option value={"اسفند"}>اسفند</option>

                  </select>
                </div>}
              </div>
            </> : <></>}
            {/*  ***************************************************************************************************/}
            {programmersSection === true ? <>
              <div className="form-control0">
                <div style={{}}>
                  <select onChange={onChangeProgrammerList} defaultValue={"nullSelect"}
                          className="form-select form-select mb-3" aria-label=".form-select-lg example">
                    <option hidden={true} value={"nullSelect"}>انتخاب برنامه نویس</option>
                    {programmersList.map(v => <option value={v.id}>{v.name}</option>)}

                  </select>
                </div>
                {showTaskSection && <div style={{}}>
                  <select ref={taskListRef} onChange={onChangeTaskSelectType2} defaultValue={"nullSelect"}
                          className="form-select form-select mb-3" aria-label=".form-select-lg example">
                    <option hidden={true} value={"nullSelect"}>انتخاب تسک</option>
                    {taskList.map(v => <option value={v.id}>{v.name}</option>)}


                  </select>
                </div>}
              </div>
            </> : <></>}
          </div>


        </>
      }
      {props.filterType === "noFilter" &&
        <>

        </>
      }


    </>
  );
};

export default AdminFilters;
